export default __webpack_public_path__ + "static/media/enter_poster_page_content.666495f6.png";